/*
import { Module } from "vuex-module-decorators";
@Module({ namespaced: true })
class FirebaseConfig {
  public name = "evoluq-staging";
  public apiKey = "AIzaSyCbx1ZxFTQhgq1PdzxlMeoo4C2EHRvlP3o";
  public authDomain = "evoluq-staging.firebaseapp.com";
  public databaseURL = "https://evoluq-staging.firebaseio.com";
  public projectId = "evoluq-staging";
  public storageBucket = "evoluq-staging.appspot.com";
  public messagingSenderId = "403132362781";
  public appId = "1:403132362781:web:69df51002361ad4c99d6f4";
  public mesurementId = "G-JC8KGEJ2CS";
}
export default FirebaseConfig;

*/
const config = {
  name: process.env.VUE_APP_FIREBASE_NAME,
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTE_ID
};
console.log("USING CONFIG: " + JSON.stringify(config));
/*
let config = {
  name: "evoluq-staging",
  apiKey: "AIzaSyCbx1ZxFTQhgq1PdzxlMeoo4C2EHRvlP3o",
  authDomain: "evoluq-staging.firebaseapp.com",
  databaseURL: "https://evoluq-staging.firebaseio.com",
  projectId: "evoluq-staging",
  storageBucket: "evoluq-staging.appspot.com",
  messagingSenderId: "403132362781",
  appId: "1:403132362781:web:69df51002361ad4c99d6f4",
  measurementId: "G-JC8KGEJ2CS"
};
console.log("process.env.GCLOUD_PROJECT: " + process.env.GCLOUD_PROJECT);
if (process.env.GCLOUD_PROJECT == 'evoluq-prod') {
  config = {
    name: "evoluq-prod",
    apiKey: "AIzaSyBf2o92gaFOA1cmhqZRO-lMgrENpzOSa6A",
    authDomain: "evoluq-prod.firebaseapp.com",
    projectId: "evoluq-prod",
    storageBucket: "evoluq-prod.appspot.com",
    messagingSenderId: "449973579375",
    appId: "1:449973579375:web:28c0f7c42222a8b47be79a",
    measurementId: "G-4F1Z9384JN",
    databaseURL: "https://evoluq-prod.firebaseio.com",
  };
}
*/

export default config;
